// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2hCOK","file":"styles_file__2kuuA"};